<template>
    <div class="form-widget-wrapper">
        <div class="widget-operator">
            <span class="op">
                <i class="delete" @click="deleteWidget"></i>
            </span>
            <span class="op">
                <i class="transfer" @mousedown="transPosition"></i>
            </span>
        </div>
        <component :is="widget.wtType" :data="widget" />
    </div>
</template>

<script>
import Options from "./formWidgets/Options";
import SingleText from "./formWidgets/SingleText";
import MultilineText from "./formWidgets/MultilineText";
import UpPicture from "./formWidgets/UpPicture";
import Time from "./formWidgets/Time";
import RoleMessage from "./formWidgets/RoleMessage";

export default {
    name: "FormWidgetWrapper",
    props: ["widget"],
    components: {
        Options,
        SingleText,
        MultilineText,
        UpPicture,
        Time,
        RoleMessage
    },
    methods: {
        deleteWidget() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.form.deleteComponentTip"),
                    confirm: () => {
                        this.$store.commit("zhiji/editFormContents", {
                            type: "deleteFormContent",
                            widget: this.widget
                        });
                    }
                }
            });
        },
        transPosition(event) {
            this.zhiji.dragStart(event, "form-widget-wrapper", "v", newIdx => {
                this.$store.commit("zhiji/editFormContents", {
                    type: "transferFormContent",
                    widget: {
                        newIdx: newIdx,
                        uId: this.widget.uId
                    }
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.form-widget-wrapper {
    padding-top: 32px;
    display: flex;
    flex-direction: row;

    .widget-operator {
        display: inline-flex;
        flex-direction: column;
        margin-right: 10px;

        .op {
            margin-bottom: 8px;
            cursor: pointer;
            display: inline-flex;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
            background: #fff;
        }

        .delete,
        .transfer {
            position: relative;
            display: inline-block;
            width: 16px;
            height: 18px;
            margin: 0 5px 0 5px;
            vertical-align: middle;
            background: url("@{zhijiStaticImagePath}class-spr.png");
        }

        .transfer {
            width: 13px;
            background-position: -113px 0;

            &:hover {
                background-position: -113px -22px;
            }
        }

        .delete {
            background-position: -96px 0;

            &:hover {
                background-position: -96px -22px;
            }
        }
    }

    &.moving {
        user-select: none;
    }
}
</style>
